export const FAN_FEED_TAGS = 'tags'
export const FAN_FEED_POSTS = 'posts'
export const FAN_FEED_SLIDESHOW = 'random_list'


// WEBPACK FOOTER //
// ./src/api/fan_feed/index.ts